import { FC } from 'react'
import { Text, FormFieldRequired } from '../../'

type FormLabelProps = {
  className?: string,
  htmlFor?: string,
  required?: boolean,
  inline?: boolean,
  size?: string,
  weight?: string
}

const FormLabel:FC<FormLabelProps> = ({ className, children, htmlFor, required = false, inline = false, size = '14', weight = 'semibold' }) => {
  return (
    <Text
      component="label"
      htmlFor={htmlFor}
      size={size}
      weight={weight}
      inline
      className={className}
    >{children} {required ? <FormFieldRequired /> : ''}</Text>
  )
}

export { FormLabel }